export enum AuditFormScheduleStatusEnum {
  NEW = 'NEW',
  VIEWED = 'VIEWED',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
  DEACTIVATED = 'DEACTIVATED'
}
